import * as R from "ramda";
const getCodeOrder = (data) => {
  if (R.isNil(data)) return -1;
  if (R.isNil(data.annotations)) return -1;
  if (!R.is(Array, data.annotations)) return -1;
  const annotation = R.find((a) => {
    if (R.isNil(a)) return false;
    return a.type === "ORDER";
  }, data.annotations);
  if (R.isNil(annotation)) return -1;
  const value = R.prop("text", annotation);
  if (R.isNil(value)) return -1;
  return Number(value);
};
export {
  getCodeOrder
};
